// @flow

import React from "react";
import AppBar from "material-ui/AppBar";
import { Title, MenuButton } from "../../../components/header";
import { blueHiThere } from "../../../styling";
import DownloadAddressesButton from "./downloadAddress";

const style: React.CSSProperties = {
  backgroundColor: blueHiThere,
  position: "fixed",
};

const Header = () => (
  <AppBar
    style={style}
    title={<Title title="Communicatie" />}
    iconElementLeft={<MenuButton />}
    iconElementRight={<DownloadAddressesButton />}
  />
);

export default Header;
